import React, { Component } from 'react';
import { connect } from "react-redux";
import { debounce } from "lodash";

import axios from "axios";

import { setVehicleDb, setProfileDb } from '../../Actions/dataActions'
import { setList } from '../../Actions/stakeholderActions'
import { ActionCheck } from './Buttons/Icons';

class Stars extends Component {
    constructor(props) {
        super(props);

        this.setStarAmount = this.setStarAmount.bind(this);
        this.submitChange = debounce(this.submitChange.bind(this), 500);

        this.state = {
            initial_star: 0,
            new_star_rating: 0,
            confirm: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.star !== this.state.initial_star) {
            this.setState({
                initial_star: nextProps.star,
                new_star_rating: nextProps.star
            })
        }
    }

    componentDidMount() {
        this.setState({
            initial_star: this.props.star,
            new_star_rating: this.props.star,
        })
    }

    submitChange() {
        var self = this;
        if (this.state.confirm) {
            if (this.props.type === "Vehicle") {
                axios.post('/ajax/tiers/vehicle/' + this.props.ID, {
                    star: self.state.new_star_rating
                })
                .then(function() {
                    self.setState({
                        confirm: false,
                        initial_star: self.state.new_star_rating
                    })
                    var vehicle_db = self.props.data.vehicle_db
                    vehicle_db[self.props.ID].tier[0].Rank = self.state.new_star_rating
                    self.props.dispatch(setVehicleDb([], vehicle_db))
                })
            } else if (this.props.type === "Profile") {
                axios.post('/ajax/tiers/user/' + this.props.ID, {
                    star: self.state.new_star_rating
                })
                .then(function() {
                    self.setState({
                        confirm: false,
                        initial_star: self.state.new_star_rating
                    })
                    var profile_db = self.props.data.profile_db
                    profile_db[self.props.ID].sh_vmh_access[0].tier.Rank = self.state.new_star_rating
                    self.props.dispatch(setProfileDb([], profile_db))
                })
            }
        }
    }

    setStarAmount(value) {
        if (this.props.mutable && this.props.confirmable) {
            if (this.props.confirmable && value !== this.state.initial_star) {
                var confirm = this.props.confirmable
            } else {
                var confirm = false
            }
    
            this.setState({
                confirm: confirm,
                new_star_rating: value
            })
        } else if (this.props.mutable) {
            this.setState({
                initial_star: value,
                new_star_rating: value
            })

            if (this.props.updateForm) {
                this.props.updateForm(value)
            }
        }
    }

    render(props) {
        return (
            <div className='rating-stars' >
                <ul id='stars'>
                    {
                        this.props.type && this.props.type === "Vehicle" ?
                            
                            <li className={'star tier-hidden' + (this.state.initial_star === 6 || this.state.new_star_rating === 6 ? " selected" : "")} key={"hidden_vehicle"} onClick={() => {this.setStarAmount(6)}}>
                                <i className='fa fa-eye-slash fa-fw'></i>
                            </li>
                        :
                            null
                    }
                    {
                        this.state.initial_star <= 5 ? 
                            Array.from(new Array(this.state.initial_star), (val, index)=> index).map((index) => {
                                return(
                                    <li className={'star tier' + (this.state.new_star_rating !== this.state.initial_star && (this.state.new_star_rating < (index + 1) || this.state.new_star_rating === 6) ? " selected-down" : " selected")} key={"full_star_" + (index + 1)} onClick={() => {this.setStarAmount(index + 1)}}>
                                        <i className='fa fa-star fa-fw'></i>
                                    </li>
                                )
                            })
                        :
                            null
                    }
                    {
                        this.state.initial_star <= 5 ? 
                            Array.from(new Array(5 - this.state.initial_star), (val, index)=> index).map((index) => {
                                return(
                                    <li className={'star tier' + (this.state.new_star_rating !== this.state.initial_star && this.state.new_star_rating >= (index + this.state.initial_star + 1) && this.state.new_star_rating !== 6 ? " selected-up" :  "")} key={"unfilled_star_" + (index + this.state.initial_star + 1)} onClick={() => {this.setStarAmount(index + this.state.initial_star + 1)}}>
                                        <i className='fa fa-star fa-fw'></i>
                                    </li>
                                )
                            })
                        :
                            Array.from(new Array(5), (val, index)=> index).map((index) => {
                                return(
                                    <li className={'star tier' + (this.state.new_star_rating !== this.state.initial_star && this.state.new_star_rating >= (index  + 1) && this.state.new_star_rating !== 6 ? " selected-up" :  "")} key={"unfilled_star_" + (index + 1)} onClick={() => {this.setStarAmount(index + 1)}}>
                                        <i className='fa fa-star fa-fw'></i>
                                    </li>
                                )
                            })
                    }
                    { this.props.mutable && this.props.confirmable ?
                        <a className="ml-8 no-margin" style={this.state.confirm ? {visibility: 'inherit'} : {visibility: 'hidden'}} onClick={this.submitChange}>{ActionCheck()}</a>
                    : null}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder,
    data: store.data
})

export default connect(mapStateToProps)(Stars)